// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file issues/v1/board_rank.proto (package github.issues.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file issues/v1/board_rank.proto.
 */
export const file_issues_v1_board_rank: GenFile = /*@__PURE__*/
  fileDesc("Chppc3N1ZXMvdjEvYm9hcmRfcmFuay5wcm90bxIQZ2l0aHViLmlzc3Vlcy52MSJfChBCb2FyZFJhbmtSZXF1ZXN0EgoKAmlkGAEgASgJEisKBWFmdGVyGAIgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEhIKCnJhbmtfZmlyc3QYAyADKAkiHwoRQm9hcmRSYW5rUmVzcG9uc2USCgoCaWQYASABKAliBnByb3RvMw", [file_google_protobuf_wrappers]);

/**
 * One drop that changes where cards sit in a view's manual order. The route names the view, so
 * the body does not.
 *
 * @generated from message github.issues.v1.BoardRankRequest
 */
export type BoardRankRequest = Message<"github.issues.v1.BoardRankRequest"> & {
  /**
   * The dragged card's global id. Echoed back verbatim in the response.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * The last ranked card above the drop point. Unset when the drop is above every ranked card.
   *
   * @generated from field: google.protobuf.StringValue after = 2;
   */
  after?: string;

  /**
   * The unranked cards above the drop point in its cell, top to bottom. They are ranked ahead of
   * the dragged card, which is what keeps the drop where the viewer put it.
   *
   * @generated from field: repeated string rank_first = 3;
   */
  rankFirst: string[];
};

/**
 * Describes the message github.issues.v1.BoardRankRequest.
 * Use `create(BoardRankRequestSchema)` to create a new message.
 */
export const BoardRankRequestSchema: GenMessage<BoardRankRequest> = /*@__PURE__*/
  messageDesc(file_issues_v1_board_rank, 0);

/**
 * @generated from message github.issues.v1.BoardRankResponse
 */
export type BoardRankResponse = Message<"github.issues.v1.BoardRankResponse"> & {
  /**
   * Echoed from the request, byte for byte.
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message github.issues.v1.BoardRankResponse.
 * Use `create(BoardRankResponseSchema)` to create a new message.
 */
export const BoardRankResponseSchema: GenMessage<BoardRankResponse> = /*@__PURE__*/
  messageDesc(file_issues_v1_board_rank, 1);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(BoardRankRequestSchema, "a1a69a7c7b7d")
registerSchemaHash(BoardRankResponseSchema, "68f49da12414")
